import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Button,
  Typography,
  Container,
  CircularProgress,
  CardContent,
  Card,
} from "@mui/material";
import API_URL from "../../config";
import API_BASE_URL from "../../utils/api";

const VerifyEmail = () => {
  const [token, setToken] = useState(null);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log("location.search is:", location.search);
    const searchParams = new URLSearchParams(location.search);
    const tokenFromURL = searchParams.get("token");

    console.log("Extracted token:", tokenFromURL);

    if (tokenFromURL) {
      setToken(tokenFromURL);
    } else {
      setMessage("Invalid or missing verification token.");
    }
  }, [location]);

  const handleVerify = async () => {
    if (!token) {
      setMessage("No token found, please check your link.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/auth/verify-email`, {
        token,
      });
      setMessage(res.data.message);
      setVerified(true);
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      setMessage(err.response?.data?.error || "Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: 80 }}>
      <Card elevation={4}>
        <CardContent style={{ textAlign: "center" }}>
          <Typography variant="h4" gutterBottom>
            Email Verification
          </Typography>
          {loading ? (
            <CircularProgress style={{ marginTop: 20 }} />
          ) : verified ? (
            <Typography
              variant="h6"
              color="success.main"
              style={{ marginTop: 20 }}
            >
              {message}
            </Typography>
          ) : (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={handleVerify}
                style={{ marginTop: 20 }}
                disabled={!token}
              >
                Verify Email
              </Button>
              {message && (
                <Typography
                  variant="body1"
                  color="error"
                  style={{ marginTop: 10 }}
                >
                  {message}
                </Typography>
              )}
            </>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default VerifyEmail;
